import LogoStack from '@components/LogoStack';
import SendOutlined from '@mui/icons-material/SendOutlined';
import { Box, Button, Typography } from '@mui/material';
import LogoutFooter from './LogoutFooter';
import { Link } from 'react-router-dom';

const NotAdminMessage = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', paddingTop: '9vh' }}>
            <LogoStack />
            <div
                style={{
                    marginTop: '6vh',
                    marginBottom: '6vh',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Box
                    sx={{
                        width: '60%',
                        alignSelf: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Typography
                        variant="h5"
                        sx={{
                            textAlign: 'center',
                        }}
                    >
                        No surveys available. Contact an administrator for access.
                    </Typography>
                    <Button
                        component={Link}
                        color="info"
                        endIcon={<SendOutlined />}
                        to="/request-access"
                        sx={{ marginTop: '6vh', width: 250 }}
                        title="Request Access"
                        variant="contained"
                    >
                        Request Access
                    </Button>
                </Box>
                <Box
                    sx={{
                        padding: '6vh',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <LogoutFooter />
                </Box>
            </div>
        </div>
    );
};

export default NotAdminMessage;
